import { Filter, FilterBase } from "../filter/filter.model";
import { ProcedureFormBase } from "./procedure-form.model";


export class ProcedureFormFilterBase extends FilterBase<ProcedureFormBase> implements Filter {

    id!: number

    formPreview: boolean = false
    formDelete: boolean = false

}

export interface ProcedureFormFilter extends ProcedureFormFilterBase { }